<template>
  <div style="height: 100%;">
    <my-header>
      答题
    </my-header>
    <video ref="input_video" width="100%" height="100%" style="display: none;"></video>
    <canvas
        class="output_canvas"
        ref="output_canvas"
        :width="width"
        :height="height"
    />
    <template v-if="questions.length">
      <van-cell style="font-size: 3rem; line-height: 3rem;">
        {{questionIndex + 1}}.{{questions[questionIndex]['title']}}
      </van-cell>
      <template v-if="questions[this.questionIndex]['type'] == 'select'">
        <van-cell v-for="(option, key) in questions[questionIndex]['options']" :key="key">
          {{String.fromCharCode(65 + key)}}：{{option}}
        </van-cell>
      </template>
    </template>
  </div>
</template>

<script>
import { Pose, POSE_CONNECTIONS } from "@mediapipe/pose";
import { Camera } from "@mediapipe/camera_utils";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import {Field, Button, Toast, Cell, CellGroup, Row, Col, Dialog} from 'vant'
import { checkWrongPose, checkRightPose } from '@/utils/mediapipe'
import {getList, getRands} from "@/api/question";

export default {
  name: "question",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data: function() {
    return {
      camera: null,
      number: null,
      ctx: null,
      width: null,
      height: null,
      timeout: 3,
      waiting: false,
      timer: null,
      rightCount: 0,
      wrongCount: 0,
      handsImage: '',
      squats: {
        count: 0,
        direction: '', // 移动方向
        rightCount: 0,
        wrongCount: 0
      },
      questions: [],
      questionIndex: 0,
      rightResCount: 0
    };
  },
  computed: {
    inputVideo() {
      return this.$refs.input_video;
    },
  },
  mounted() {
    this.ctx = this.$refs.output_canvas.getContext("2d");
    this.getQuestions().then(res => {
      this.init();
    })
  },
  methods: {
    init() {
      this.handsImage = new Image();
      this.handsImage.src = require('@/assets/hands.png');
      window.requestAnimationFrame(this.pose);
    },
    pose() {
      const pose = new Pose({
        locateFile: (file) => {
          console.log(file)
          // return `http://localhost:8080/static/@mediapipe/hands@0.4.1646424915/${file}`;

          // 只有这个固定版本正常，更高的版本都报错，暂时不知道原因
          return `/static/@mediapipe/pose@0.5.1635988162/${file}`;
          return `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5.1635988162/${file}`;
        },
      });
      pose.setOptions({
        modelComplexity: 1,
        smoothLandmarks: true,
        enableSegmentation: true,
        smoothSegmentation: true,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
      });
      pose.onResults(this.onResults);

      this.camera = new Camera(this.inputVideo, {
        onFrame: async () => {
          await pose.send({ image: this.inputVideo })
        },
      })
      this.camera.start()
    },
    calcDistance(p1, p2) {
      const distance = Math.sqrt(Math.abs(Math.pow(p1['x'] - p2['x'], 2))
          + Math.abs(Math.pow(p1['y'] - p2['y'], 2))
          + Math.abs(Math.pow(p1['z'] - p2['z'], 2)))
      return distance
    },
    calcDistanceBy2D(p1, p2) {
      const distance = Math.sqrt(Math.abs(Math.pow(p1['x'] - p2['x'], 2))
          + Math.abs(Math.pow(p1['y'] - p2['y'], 2)))
      return distance
    },
    calcAgentBy2DPoint(A, B, C) {
      const a = this.calcDistanceBy2D(B, C)
      const b = this.calcDistanceBy2D(A, C)
      const c = this.calcDistanceBy2D(A, B)
      return this.calcAgentByLength(a, b, c)
    },
    calcAgentByPoint(A, B, C) {
      const a = this.calcDistance(B, C)
      const b = this.calcDistance(A, C)
      const c = this.calcDistance(A, B)
      return this.calcAgentByLength(a, b, c)
    },
    calcAgentByLength(a, b, c) {
      const cosA = (Math.pow(b, 2) + Math.pow(c, 2) - Math.pow(a, 2)) / (2*b*c)
      const agent = Math.acos(cosA) * 180 / Math.PI
      return agent
    },
    checkAnswer(answer) {
      if(answer === this.questions[this.questionIndex]['answer']) {
        this.rightResCount++
        Toast('答对了')
      }else{
        Toast('答错了')
      }
      if(this.questions.length - 1 > this.questionIndex){
        this.questionIndex++
      }else{
        Dialog.alert({
          title: '答题结束',
          message: '答对了' + this.rightResCount + '题',
        })
            .then(() => {
              this.rightResCount = 0
              this.questionIndex = 0
            })
      }
    },
    onResults(results) {
      this.width = results.image.width;
      this.height = results.image.height;
      this.ctx.save();
      this.ctx.clearRect(0, 0, results.image.width, results.image.height);
      // 下面两句翻转
      this.ctx.translate(results.image.width, 0);
      this.ctx.scale(-1, 1);

      // console.log(results.image)
      this.ctx.drawImage(
          results.image,
          0,
          0,
          results.image.width,
          results.image.height
      );

      // this.findHands(results);

      if (results.poseLandmarks) {

        drawConnectors(this.ctx, results.poseLandmarks, POSE_CONNECTIONS, {
          color: "#00FF00",
          lineWidth: 4,
        });
        drawLandmarks(this.ctx, results.poseLandmarks, {
          color: "#FF0000",
          lineWidth: 2,
        })
        this.ctx.restore();

        this.ctx.font = '80px STheiti, SimHei'
        this.ctx.fillStyle = "green"
        this.ctx.fillText(this.questions[this.questionIndex]['title'], 30, 100, this.width)

        if(this.questions[this.questionIndex]['type'] == 'select'){
          this.ctx.font = '100px STheiti, SimHei'
          this.ctx.fillStyle = "green"
          const optLen = this.questions[this.questionIndex]['options'].length
          const eachOptWidth = (this.width) / optLen
          for (const key in this.questions[this.questionIndex]['optionsData']){
            this.questions[this.questionIndex]['optionsData'][key]['position'] = {x: eachOptWidth*(key*1 + 0.5), y: this.height/2 }
            this.ctx.fillText(String.fromCharCode(65 + key*1), eachOptWidth*(key*1 + 0.5), this.height/2, 200)
          }
          this.checkHandsPosition(results.poseLandmarks[20])

        }

        if(this.questions[this.questionIndex]['type'] == 'judge'){
          checkWrongPose(results.poseLandmarks).then(res => {
            this.wrongCount ++
            if(this.wrongCount >= 50){
              this.wrongCount = 0
              this.checkAnswer(0)
            }
          }).catch(err => {
            // console.log(err)
          })

          checkRightPose(results.poseLandmarks).then(res => {
            this.rightCount ++
            if(this.rightCount >= 50){
              this.rightCount = 0
              this.checkAnswer(1)
            }
          }).catch(err => {
            // console.log(err)
          })
        }
        // this.ctx.restore();
        // }
      }else{
        this.ctx.restore();
      }

    },
    checkHandsPosition(position){

      const options = this.questions[this.questionIndex]['optionsData']

      for (let i in options) {
        const width = Math.abs((position.x * this.width) - options[i]['position']['x'])
        const height = Math.abs((position.y * this.height) - options[i]['position']['y'])
        const tmpCounter = options[i]['counter']
        options[i]['counter'] = 0
        if(width < 80 && height < 80){
          options[i]['counter'] = tmpCounter + 1
          if(options[i]['counter'] > 50) {
            this.checkAnswer(i*1)
          }
        }
      }

    },
    getQuestions() {
      getRands()
      return getList().then(res => {
        for (let i in res.data.data){
          res.data.data[i]['optionsData'] = []
          for (let j in res.data.data[i]['options']){
            res.data.data[i]['optionsData'].push({counter: 0})
          }
        }
        this.questions = res.data.data
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.camera.stop()
    next()
  }
}
</script>

<style scoped>
.output_canvas {
  width: 100%;
  height: 100%;
}
.question{
  position: absolute;
  text-align: center;
  width: 100%;
  font-size: 5rem;
}
</style>
